import React from "react";
import "../App.css";
import image1 from "../images/image856.png";
import image2 from "../images/image867.png";
import image3 from "../images/image878.png";
import image4 from "../images/image950.png";
import heroScreen1 from "../images/ScreenTelephone1GymNote.png";
import heroScreen2 from "../images/ScreenTelephone2GymNote.png";
import logo from "../images/favicon.png";
import playstore from "../images/playstore.png";
import circleBackground from "../images/circleBackGround.svg";
import imageCoach1 from "../images/imageCoach1.png";
import imageCoach2 from "../images/imageCoach2.png";
import imageCoach3 from "../images/imageCoach3.png";

function Home() {
	return (
		<div className="page">
			<div className="page-content">
				<div className="hero-banner">
					<div className="hero-content">
						<div className="hero-text">
							<h1 className="hero-title">
								<span className="highlight">G</span>ym
								<span className="highlight">N</span>ote
							</h1>
							<p className="hero-description">
								GymNote est une application simple et intuitive à utiliser à la
								salle de sport. Elle va te permettre de noter tes performances
								sur chaque série de chaque exercice, séance après séance.
							</p>
						</div>
						<div className="hero-logo-box hero-logo-mobile">
							<img src={logo} alt="Gymnote logo" className="hero-logo" />
						</div>
					</div>
					<div className="hero-images">
						<img
							src={heroScreen1}
							alt="Gymnote screenshot"
							className="hero-image"
						/>
						<img
							src={heroScreen2}
							alt="Gymnote screenshot"
							className="hero-image"
						/>
					</div>
					<div className="hero-right">
						<div className="hero-logo-box">
							<img src={logo} alt="Gymnote logo" className="hero-logo" />
						</div>
						<a
							href="https://play.google.com/store/apps/details?id=com.frenchmatrix.GymNote"
							target="_blank"
							rel="noopener noreferrer"
						>
							<img
								src={playstore}
								alt="Get it on Play Store"
								className="hero-playstore"
							/>
						</a>
					</div>
				</div>
				<div className="screenshots-section">
					<div className="screenshot-item screen-high">
						<img
							src={image2}
							alt="Gymnote screenshot"
							className="screen-image"
						/>
						<p className="screenshot-subtitle">CHALLENGE-TOI À CHAQUE SÉANCE</p>
						<p className="screenshot-text">
							Tes anciennes perfs s'affichent directement, à toi de les dépasser
							!
						</p>
					</div>
					<div className="screenshot-item screen-low">
						<img
							src={image3}
							alt="Gymnote screenshot"
							className="screen-image"
						/>
						<p className="screenshot-subtitle">
							MOTIVE-TOI EN SUIVANT TES GYMBRO
						</p>
						<p className="screenshot-text">
							Ajoute tes amis pour suivre leurs records et leurs performances
							sur la semaine !
						</p>
					</div>
					<div className="screenshot-item screen-mid">
						<img
							src={image4}
							alt="Gymnote screenshot"
							className="screen-image"
						/>
						<p className="screenshot-subtitle">PERSONNALISE TES EXERCICES</p>
						<p className="screenshot-text">
							Ajoute et ajuste tes exercices selon tes objectifs et tes
							préférences !
						</p>
					</div>
				</div>
				<div className="cta-section">
					<img src={image1} alt="Gymnote screenshot" className="cta-image" />
					<div className="cta-content">
						<h2 className="cta-title">
							<span className="highlight">G</span>ym
							<span className="highlight">N</span>ote
						</h2>
						<p className="cta-subtitle">PROPOSE UNE FONCTIONNALITÉ UNIQUE</p>
						<p className="cta-feature">LE MODE COACH</p>
						<p className="cta-tag">COULEURS D'INTERFACE DIFFÉRENTES</p>
						<p className="cta-tag">UN SUIVI EN TEMPS RÉEL</p>
						<p className="cta-description">
							Le Mode Coach est une innovation pour le coaching en musculation.
							Passe ton profil en mode coach puis consulte, annote, et organise
							les séances de tes élèves en temps réel. Assure un suivi
							millimétré de leurs performances pour maximiser leur progression,
							tout en économisant un maximum de ton temps précieux !
						</p>
					</div>
				</div>
				<div className="coach-features-section">
					<div className="coach-feature-item">
						<img
							src={imageCoach3}
							alt="Ajoute tes élèves"
							className="coach-feature-image"
						/>
						<p className="coach-feature-title">AJOUTE TES ÉLÈVES</p>
						<p className="coach-feature-text">
							Tes élèves ont juste à installer GymNote et accepter ton
							invitation !
						</p>
					</div>
					<div className="coach-feature-item">
						<img
							src={imageCoach1}
							alt="Ajoute des notes"
							className="coach-feature-image"
						/>
						<p className="coach-feature-title">PRÉPARE LEURS ENTRAÎNEMENTS</p>
						<p className="coach-feature-text">
							Choix des exercices, nombre de séries, charges de travail, c'est
							toi qui gères !
						</p>
					</div>
					<div className="coach-feature-item">
						<img
							src={imageCoach2}
							alt="Suit ses performances"
							className="coach-feature-image"
						/>
						<p className="coach-feature-title">SUIS SES PERFORMANCES</p>
						<p className="coach-feature-text">
							Ajuste son programme en temps réel pour une progression optimale !
						</p>
					</div>
				</div>
				<div className="orange-banner">
					<h2 className="orange-title">ABONNEMENTS</h2>
					<div className="pricing-cards">
						<div className="pricing-card">
							<p className="pricing-name">Starter</p>
							<p className="pricing-price">
								€ 19.99<span>/mo</span>
							</p>
							<ul className="pricing-features">
								<li>10 élèves maximum</li>
								<li>12 mois d'engagement</li>
								<li>Entraînements illimités</li>
								<li>Synchronisation cloud</li>
								<li>Templates personnalisés</li>
							</ul>
						</div>
						<div className="pricing-card pricing-card-featured">
							<p className="pricing-name">Pro</p>
							<p className="pricing-price">
								€ 34.99<span>/mo</span>
							</p>
							<ul className="pricing-features">
								<li>50 élèves maximum</li>
								<li>12 mois d'engagement</li>
								<li>Entraînements illimités</li>
								<li>Synchronisation cloud</li>
								<li>Templates personnalisés</li>
							</ul>
						</div>
						<div className="pricing-card">
							<p className="pricing-name">Elite</p>
							<p className="pricing-price">
								€ 39.99<span>/mo</span>
							</p>
							<ul className="pricing-features">
								<li>100 élèves maximum</li>
								<li>12 mois d'engagement</li>
								<li>Entraînements illimités</li>
								<li>Synchronisation cloud</li>
								<li>Templates personnalisés</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Home;
